/**
 * Contact Form Fields.
 * @format
 */

import { functionalRoles } from '../../form-components/lists/functional-roles';

export const simpleContactFormFields = [
  {
    fieldTitle: 'First name',
    fieldName: 'FirstName',
    id: 'fname',
    type: 'text',
    placeholderText: 'Your first name here',
    errorMessage: 'First Name field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Last name',
    fieldName: 'LastName',
    id: 'lname',
    type: 'text',
    placeholderText: 'Your last name here',
    errorMessage: 'Last Name field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Email address',
    fieldName: 'Email',
    id: 'email',
    type: 'email',
    placeholderText: 'name@website.com',
    errorMessage: 'Invalid email.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Company Name',
    fieldName: 'Company',
    id: 'organization',
    type: 'text',
    placeholderText: "Your company's name",
    errorMessage: 'Company name field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Functional role',
    fieldName: 'Functional_role__c',
    id: 'functional-role-select',
    type: 'select',
    placeholderText: 'Select a role',
    errorMessage: 'Functional role field required.',
    required: true,
    list: functionalRoles,
    useNameAsLookupValue: true,
    parentItems: [
      { value: 'Chief/Dept Administrator' },
      { value: 'IT - Management' },
      { value: 'IT - Technician' },
      { value: 'Nurse' },
      { value: 'Nurse - Manager' },
      { value: 'Physician' },
      { value: 'Therapist/Technician/Technologist/Operator' },
      { value: 'Therapist - Chief' },
      { value: 'Veterinary Staff' },
    ],
    dependencyId: 'specialty-select',
  },
  {
    fieldTitle: 'Comment',
    fieldName: 'mktoCommentCapture',
    id: 'comment',
    type: 'textarea',
    placeholderText: '',
    errorMessage: '',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
];
